var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('AsyncLSelect', _vm._g(_vm._b({
    attrs: {
      "close-on-select": _vm.closeOnSelect
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slotName) {
      return {
        key: slotName,
        fn: function (_ref) {
          var data = _ref.data;
          return [_vm._t(slotName, null, {
            "data": data
          })];
        }
      };
    }), {
      key: "option-content",
      fn: function (_ref2) {
        var _ref2$data = _ref2.data,
          optionsData = _ref2$data.optionsData,
          handleClickOptionItem = _ref2$data.handleClickOptionItem,
          checkItemIsSelected = _ref2$data.checkItemIsSelected;
        return [_c('OptionItems', {
          attrs: {
            "checkItemIsSelected": checkItemIsSelected,
            "handleClickOptionItem": handleClickOptionItem,
            "multiple": _vm.multiple,
            "optionsData": optionsData
          }
        })];
      }
    }], null, true)
  }, 'AsyncLSelect', _vm.$props, false), _vm.$listeners))], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }